import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  TextField,
} from "@mui/material";
import AddFeedbackStar from "./AddFeedbackStar";

export default function AddFeedbackModal({
  open,
  handleClose,
  onSubmitBtn,
  onChange,
  value,
  type,
  feedbackData,
}) {
  const [inputFields, setInputFields] = useState([]);
  const [inputValue, setInputValue] = useState(null);
  const [startChanges, setStartChanges] = useState(false);
  const [chipstatus, setChipstatus] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = (event, value) => {
    setChipstatus(true);
    setStartChanges(true);
    setError(false);
    event.preventDefault();
    setInputFields(value);
  };

  const onInputChangeVal = (event, value) => {
    setStartChanges(true);
    const chip = value ? value : null;
    setError(false);
    setInputValue(chip);
  };

  const handleCloseModal = (event, reason) => {
    if (reason !== "backdropClick") {
      setInputFields([""]);
      setStartChanges(false);
      setInputValue(null);
      handleClose();
      setError(false);
      setChipstatus(false);
    }
  };

  const onDialog = () => {
    let data = [];
    if (inputFields && inputFields[0]?.length > 0) {
      const val = inputFields?.includes(inputValue);
      if (val) {
        data = inputFields;
      } else {
        data = [...inputFields, inputValue];
      }
    } else {
      const val = feedbackData?.tags?.includes(inputValue);
      if (val && !chipstatus) {
        data = feedbackData?.tags;
      } else if (chipstatus) {
        data = [inputValue];
      } else {
        data = [...feedbackData?.tags, inputValue];
      }
    }
    if (
      startChanges === false ||
      (startChanges === true &&
        (inputFields?.length > 0 ||
          (inputValue !== null && inputValue?.trim()?.length > 0)))
    ) {
      onSubmitBtn(data);
      setInputValue(null);
      setInputFields([""]);
      setStartChanges(false);
      setChipstatus(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (!open) {
      setInputFields([""]);
      setInputValue(null);
      setInputFields([""]);
      setStartChanges(false);
      setError(false);
      setChipstatus(false);
    }
  }, [open]);

  return (
    <div>
      <Dialog disableEscapeKeyDown open={open} onClose={handleCloseModal}>
        <DialogTitle className="dialogHead justifyCenter font28 fw700 colorPrimary">
          {type?.charAt(0)?.toUpperCase() + type?.slice(1)}
          <span className="colorSecondary"> &nbsp; Feedback</span>
        </DialogTitle>
        <DialogContent>
          <p className="commonformLabel">
            Rating <span className="colorRed">*</span>
          </p>
          <AddFeedbackStar
            onChange={onChange}
            value={value}
            feedbackData={feedbackData}
          />
          <Box>
            <FormControl className="settingDialogMain">
              <Box className="feedbackBox">
                <p className="commonformLabel">
                  {"Tag"}
                  <span className="colorRed">*</span>
                </p>
                <Autocomplete
                  multiple
                  id="size-small-standard-multi"
                  size="medium"
                  options={[]}
                  freeSolo
                  key={
                    (inputFields &&
                      inputFields[0]?.length > 0 &&
                      inputFields) ||
                    feedbackData?.tags
                  }
                  defaultValue={
                    (inputFields && inputFields[0]?.length > 0) || startChanges
                      ? inputFields
                      : feedbackData?.tags
                  }
                  onChange={handleSubmit}
                  onInputChange={onInputChangeVal}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      error={error}
                      helperText={error ? "This field is required." : null}
                      {...params}
                      margin="normal"
                      aria-label="enter search"
                      name="tags"
                      placeholder="Add tags"
                    />
                  )}
                />
              </Box>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
          >
            <Button
              onClick={handleClose}
              variant="contained"
              size="medium"
              className="cancelAddBtn"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                onDialog();
              }}
              variant="contained"
              size="medium"
              className="buttonSubmit"
            >
              {type === "edit" ? "Update" : "Create"}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
